module.exports = __webpack_public_path__ + "static/media/1POLICY43.d8b81022.jpg";